import template from './evidence-validation.html';
import controller from './evidence-validation.controller';
import './evidence-validation.scss';

let evidenceValidationComponent = {
    restrict: 'E',
    bindings: {},
    template: '<div class="tsa" ui-view></div>',
    controller
};

export default evidenceValidationComponent;



// WEBPACK FOOTER //
// ./src/app/components/page/verify/evidence-validation/evidence-validation.component.js